<div class="outer-container">
   <div class="apps-topbar">
      <h6 class="apps-page-subtitle">Below is a summary of your practices and their progress towards selected KPIs</h6>
      <div class="subtitle-sort">Sort by:</div>
   </div>

   <div
      *ngFor="let practice of allPractices"
      class="apps-inner-page-container">
      <a href="/growth-toolkit/regional-manager-summary/{{ practice?.practiceSKey }}">
         <vc-hospital-kpi-row
            [showHospitalName]="true"
            [showMeeting]="true"
            [showChart]="false"
            [practiceSKey]="practice.practiceSKey"></vc-hospital-kpi-row>
      </a>
   </div>
   <div class="container-spacer">&nbsp;</div>
</div>
